export const blogPosts = [
  {
    id: 1,
    title: "노숙인을 위한 김장 담그기 자원봉사 행사",
    excerpt:
      "김장 담그기 자원봉사 행사는 매년 겨울철에 이루어지는 한국의 전통적인 행사로, 이 시기에 많은 사람들이 모여 김치를 담그고 나누는 활동입니다. 특히, 노숙인을 위한 김장 담그기 자원봉사 행사는 지역 사회의 소외된 이웃들에게 따뜻한 마음을 전하는 중요한 기회입니다...",
    image:
      "https://static.wixstatic.com/media/17b604_a677eb386ca74343b4fc55c0f69678e2~mv2.png",
    author: "현주 김",
    authorAvatar:
      "https://lh3.googleusercontent.com/a/ACg8ocJPdI903jXHsujX4vubvQG7z-F-wdhhoVVsYHS9yZ8YkJfsgge6=s96-c",
    date: "6월 15일",
    readTime: "3분 분량",
    views: 0,
    likes: 0,
  },
  {
    id: 2,
    title: "플라스틱 줄이기와 다회용 컵 사용 촉진",
    excerpt:
      "플라스틱 사용이 환경에 미치는 영향은 심각합니다. 매년 수백만 톤의 플라스틱이 바다와 땅에 버려지며, 이는 생태계에 큰 위협이 됩니다. 이러한 문제를 해결하기 위해 많은 사람들이 다회용 컵 사용을 촉진하고 있습니다. 이 블로그 포스트에서는 플라스틱 줄이기와 다회용 컵 사용의 중요성에 대해 알아보겠습니다...",
    image:
      "https://static.wixstatic.com/media/17b604_e7877b92f5f34dccb10e2241b1ee00ea~mv2.png",
    author: "현주 김",
    authorAvatar:
      "https://lh3.googleusercontent.com/a/ACg8ocJPdI903jXHsujX4vubvQG7z-F-wdhhoVVsYHS9yZ8YkJfsgge6=s96-c",
    date: "6월 15일",
    readTime: "2분 분량",
    views: 2,
    likes: 1,
  },
  {
    id: 3,
    title: "환경 정화로 지구를 구하는 한마음 자원봉사단",
    excerpt:
      "지구는 우리가 살고 있는 소중한 공간입니다. 그러나 인간의 활동으로 인해 환경이 오염되고, 생태계가 파괴되고 있습니다. 이러한 문제를 해결하기 위해 많은 사람들이 자원봉사에 나서고 있습니다. 그 중에서도 한마음 자원봉사단은 환경 정화 활동을 통해 지구를 구하는 데 앞장서고 있습니다...",
    image:
      "https://static.wixstatic.com/media/17b604_c7c65af9dfaf4b30b0169e0e4169e8e0~mv2.png",
    author: "현주 김",
    authorAvatar:
      "https://lh3.googleusercontent.com/a/ACg8ocJPdI903jXHsujX4vubvQG7z-F-wdhhoVVsYHS9yZ8YkJfsgge6=s96-c",
    date: "6월 15일",
    readTime: "2분 분량",
    views: 2,
    likes: 0,
  },
];